import { Injectable } from '@angular/core';
import { Course, Learnspace } from '@shared/models';
import { BehaviorSubject } from 'rxjs';
export type AppMode = 'default' | 'analytics' | 'hubedit' | 'account' | 'contribute';
@Injectable()
export class CurrentContextService {
  private appModeSubject = new BehaviorSubject<AppMode>('default');
  private learnspaceSubject = new BehaviorSubject<Learnspace | null>(null);
  private courseSubject = new BehaviorSubject<Course | null>(null);
  learnspace$ = this.learnspaceSubject.asObservable();
  course$ = this.courseSubject.asObservable();
  appMode$ = this.appModeSubject.asObservable();

  get appMode(): AppMode {
    return this.appModeSubject.value;
  }

  setAppMode(value: string) {
    let appMode: AppMode;
    switch (value) {
      case 'analytics':
        appMode = 'analytics';
        break;
      case 'account':
        appMode = 'account';
        break;
      case 'contribute':
        appMode = 'contribute';
        break;
      default:
        appMode = 'default';
    }
    if (this.appMode === value) return;
    this.appModeSubject.next(appMode);
  }
  get currentLearnspace(): Learnspace {
    return this.learnspaceSubject.getValue();
  }

  set currentLearnspace(ls: Learnspace) {
    this.learnspaceSubject.next(ls);
  }

  get currentCourse(): Course {
    return this.courseSubject.getValue();
  }
  set currentCourse(course: Course) {
    this.courseSubject.next(course);
  }
}
